/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-07-18 12:25:48
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-07-29 14:18:02
 */
const interflowList = () => import("@/views/interflow-manage/interflow-list/interflow-list.vue");
// const interflowListStaOpen = () =>
//   import(
//     "@/views/interflow-manage/interflow-list/children/sta-open-manage/sta-open-manage.vue"
//   );
// E:/chen\project-git\saas-oper-front\src\views\member-manage\corporate-member-list\children\bind-sites\bind-sites.vue
const interflowListStaOpen = () => import("@/views/member-manage/corporate-member-list/children/bind-sites/bind-sites.vue");
// const interflowListStaOpenPrice = () =>
//   import(
//     "@/views/interflow-manage/interflow-list/children/sta-open-manage/children/price.vue"
//   );
const interflowListStaOpenDetail = () => import("@/views/member-manage/corporate-member-list/children/bind-sites/bind-sites.vue");
// const interflowListQuery = () =>
//   import(
//     "@/views/interflow-manage/interflow-list/children/query-order/query-order.vue"
//   );
// const interflowListDiscount = () =>
//   import(
//     "@/views/interflow-manage/interflow-list/children/interflow-discount/interflow-discount.vue"
//   );
const interflowApplySend = () => import("@/views/interflow-manage/interflow-list/children/send/send.vue");
const interflowApplySendDetails = () => import("@/views/interflow-manage/interflow-list/children/send-details/send-details.vue");
const interflowApplyBill = () => import("@/views/interflow-manage/interflow-list/children/bill/bill.vue");
const interflowApplyBalanceReminder = () => import("@/views/public-page/balance-reminder/balance-reminder.vue");
// const interflowApplyDetail = () =>
//   import("@/views/interflow-manage/interflow-list/children/detail/detail.vue");
// const interflowSettlement = () =>
//   import(
//     "@/views/interflow-manage/interflow-list/children/interflow-settlement/interflow-settlement.vue"
//   );
// const interflowApply = () =>
//   import("@/views/interflow-manage/interflow-apply/interflow-apply.vue");
const interflowRecharge = () => import("@/views/interflow-manage/interflow-list/children/interface-recharge/interface-recharge.vue");
const interflowMoneyRecord = () => import("@/views/interflow-manage/interflow-list/children/money-record/money-record.vue");
const interflowRefund = () => import("@/views/interflow-manage/interflow-list/children/refund/refund.vue");
// const interflowApplyDetail = () =>
//   import("@/views/interflow-manage/interflow-apply/children/detail.vue");
// const interflowSettlement = () =>
//   import(
//     "@/views/interflow-manage/interflow-settlement/interflow-settlement.vue"
//   );
const routerList = [
    {
        path: "/interflow-manage/interflow-list",
        name: "互联互通列表",
        component: interflowList,
        children: [
            {
                path: "/interflow-manage/interflow-list/staOpen",
                name: "站点开放管理",
                component: interflowListStaOpen,
                meta: {
                    nameKey: "interflowStaOpen",
                },
            },
            // {
            //   path: "/interflow-manage/interflow-list/price",
            //   name: "推送价格设置",
            //   component: interflowListStaOpenPrice
            // },
            {
                path: "/interflow-manage/interflow-list/staOpen-detail",
                name: "查看详情",
                component: interflowListStaOpenDetail,
                meta: {
                    nameKey: "interflowStaOpenDetail",
                },
            },
            // {
            //   path: "/interflow-manage/interflow-list/query",
            //   name: "查询订单",
            //   component: interflowListQuery
            // },
            // {
            //   path: "/interflow-manage/interflow-list/discount",
            //   name: "互联折扣设置",
            //   component: interflowListDiscount
            // },
            {
                path: "/interflow-manage/interflow-list/send",
                name: "发起申请",
                component: interflowApplySend,
                meta: {
                    nameKey: "interflowSend",
                },
            },
            {
                path: "/interflow-manage/interflow-list/upsend",
                name: "修改互联互通",
                component: interflowApplySend,
                meta: {
                    nameKey: "interflowUp",
                },
            },
            {
                path: "/interflow-manage/interflow-list/detail",
                name: "互联互通查看详情",
                component: interflowApplySendDetails,
                meta: {
                    nameKey: "interflowDetails",
                },
            },
            {
                path: "/interflow-manage/interflow-list/bill",
                name: "对账单",
                component: interflowApplyBill,
                meta: {
                    nameKey: "interflowBill",
                },
            },
            {
                path: "/interflow-manage/interflow-list/balance-reminder",
                name: "互通余额提醒",
                component: interflowApplyBalanceReminder,
                meta: {
                    nameKey: "interflowBalance",
                },
            },
            // {
            //   path: "/interflow-manage/interflow-list/settlement",
            //   name: "结算订单补推",
            //   component: interflowSettlement
            // },
            // {
            //   path: "/interflow-manage/interflow-apply",
            //   name: "申请互联互通",
            //   component: interflowApply
            // },
            {
                path: "/interflow-manage/interflow-list/recharge",
                name: "互联互通充值",
                component: interflowRecharge,
                meta: {
                    nameKey: "interflowRecharge",
                },
            },
            {
                path: "/interflow-manage/interflow-list/money-record",
                name: "互联互通资金记录",
                component: interflowMoneyRecord,
                meta: {
                    nameKey: "interflowRecord",
                },
            },
            {
                path: "/interflow-manage/interflow-list/refund",
                name: "互联互通退款",
                component: interflowRefund,
                meta: {
                    nameKey: "interflowRefund",
                },
            },
        ],
    },
];
export default routerList;
